const l = (t) => t === !0 || t === "t" || t === 1 ? "t" : "f", b = (t) => `${t}${t.includes(".") ? "" : " option"}`;
function n(t, e, r) {
  if (t === void 0)
    throw new Error(
      `${b(e)} is undefined${r ? `. ${r}` : ""}`
    );
}
function z(t, e, r, o) {
  return `${b(t)} value can't be less${o ? " or equal" : ""} then ${e}${r ? `. ${r}` : ""}`;
}
function i(t, e, r) {
  if (typeof t != "number")
    throw new Error(
      `${b(e)} is not a number${r != null && r.addInfo ? `. ${r == null ? void 0 : r.addInfo}` : ""}`
    );
  if (!(r != null && r.addParam))
    return;
  const o = r.addParam, s = r == null ? void 0 : r.addInfo;
  if (o.min !== void 0) {
    if (o.minEqual && t <= o.min)
      throw new Error(z(e, o.min, s, !0));
    if (t < o.min)
      throw new Error(z(e, o.min, s));
    if (o.max !== void 0 && t > o.max)
      throw new Error(
        `${b(e)} value can't be more than ${o.max}${s ? `. ${s}` : ""}`
      );
  }
  if (o.isInt && !Number.isInteger(t))
    throw new Error(`${b(e)} is must be an integer`);
}
function d(t, e, r) {
  const o = `Valid values are: ${Object.keys(t).join(", ")}`;
  if (!t[e])
    throw new Error(`${b(r)} is invalid. ${o}`);
}
function _(t, e, r) {
  if (typeof t != "string")
    throw new Error(`${b(e)} is not a string`);
  if (r) {
    if (t.match(/[^0-9a-fA-F]/))
      throw new Error(`${b(e)} must be hexadecimal`);
    if (t.length !== 3 && t.length !== 6 && t.length !== 8)
      throw new Error(
        `${b(e)} must be 3, 6 or 8 characters long (with alpha)`
      );
  }
}
function $(t, e) {
  if (!Array.isArray(t))
    throw new Error(`${b(e)} is not an array`);
  if (t.length === 0)
    throw new Error(`${b(e)} is empty`);
}
function p(t, e) {
  if (typeof t != "boolean")
    throw new Error(`${b(e)} is not a boolean`);
}
const k = (t) => t.ajust || t.aj, be = (t) => !!k(t), _e = (t) => {
  const e = k(t);
  n(e, "ajust"), e.brightness && i(e.brightness, "ajust.brightness", {
    addParam: { min: -255, max: 255 }
  });
  const r = e.brightness || "", o = e.contrast || "", s = e.saturation || "";
  return `aj:${r}:${o}:${s}`;
}, me = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: _e,
  test: be
}, Symbol.toStringTag, { value: "Module" })), pe = {
  none: !0,
  size: !0,
  dssim: !0,
  ml: !0
}, B = (t) => t.autoquality || t.aq, ge = (t) => !!B(t), fe = (t) => {
  const e = B(t);
  n(e, "autoquality");
  const { method: r, target: o, min_quality: s, max_quality: a, allowed_error: c } = e;
  if (r && d(pe, r, "autoquality.method"), o && i(o, "autoquality.target", {
    addParam: { min: 0 }
  }), s && i(s, "autoquality.min_quality", {
    addParam: { min: 0, max: 100 }
  }), a && i(a, "autoquality.max_quality", {
    addParam: { min: 0, max: 100 }
  }), c) {
    if (r !== "dssim" && r !== "ml")
      throw new Error(
        "autoquality.allowed_error is applicable only to dssim and ml methods"
      );
    i(c, "autoquality.allowed_error", {
      addParam: { min: 0, max: 1 }
    });
  }
  return `aq:${r || ""}:${o || ""}:${s || ""}:${a || ""}:${c || ""}`.replace(/:+$/, "");
}, $e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: fe,
  test: ge
}, Symbol.toStringTag, { value: "Module" })), q = (t) => {
  if ("auto_rotate" in t)
    return t.auto_rotate;
  if ("ar" in t)
    return t.ar;
}, ye = (t) => q(t) !== void 0, Oe = (t) => {
  const e = q(t);
  return n(e, "auto_rotate"), `ar:${l(e)}`;
}, ve = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: Oe,
  test: ye
}, Symbol.toStringTag, { value: "Module" })), E = (t) => t.background || t.bg, he = (t) => !!E(t), je = (t) => {
  const e = E(t);
  if (n(e, "background"), typeof e == "number")
    throw new Error("background option is not a string or object");
  return typeof e == "string" ? (_(e, "background", !0), `bg:${e}`) : (n(e.r, "background.r"), n(e.g, "background.g"), n(e.b, "background.b"), i(e.r, "background.r"), i(e.g, "background.g"), i(e.b, "background.b"), `bg:${e.r}:${e.g}:${e.b}`);
}, Se = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: je,
  test: he
}, Symbol.toStringTag, { value: "Module" })), I = (t) => t.background_alpha || t.bga, we = (t) => !!I(t), ze = (t) => {
  const e = I(t);
  return n(e, "background_alpha"), i(e, "background_alpha", {
    addParam: { min: 0, max: 1 }
  }), `background_alpha:${e}`;
}, Pe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: ze,
  test: we
}, Symbol.toStringTag, { value: "Module" })), A = (t) => t.blur || t.bl, xe = (t) => !!A(t), Me = (t) => {
  const e = A(t);
  return n(e, "blur"), i(e, "blur", { addParam: { min: 0 } }), `bl:${e}`;
}, Te = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: Me,
  test: xe
}, Symbol.toStringTag, { value: "Module" })), F = (t) => t.blur_detections || t.bd, ke = (t) => !!F(t), Be = (t) => {
  const e = F(t);
  n(e, "blur_detections"), n(e.sigma, "blur_detections.sigma"), i(e.sigma, "blur_detections.sigma");
  const r = e.sigma, o = e.class_names ? e.class_names.join(":") : "";
  return `bd:${r}:${o}`.replace(/:+$/, "");
}, qe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: Be,
  test: ke
}, Symbol.toStringTag, { value: "Module" })), V = (t) => t.brightness || t.br, Ee = (t) => !!V(t), Ie = (t) => {
  const e = V(t);
  return n(e, "brightness"), i(e, "brightness", {
    addParam: { min: -255, max: 255 }
  }), `br:${e}`;
}, Ae = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: Ie,
  test: Ee
}, Symbol.toStringTag, { value: "Module" })), U = (t) => t.cachebuster || t.cb, Fe = (t) => !!U(t), Ve = (t) => {
  const e = U(t);
  return n(e, "cachebuster"), _(e, "cachebuster"), `cb:${e}`;
}, R = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: Ve,
  test: Fe
}, Symbol.toStringTag, { value: "Module" })), N = (t) => t.contrast || t.co, Ue = (t) => !!N(t), Re = (t) => {
  const e = N(t);
  return n(e, "contrast"), i(e, "contrast", { addParam: { min: 0 } }), `co:${e}`;
}, Ne = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: Re,
  test: Ue
}, Symbol.toStringTag, { value: "Module" })), C = {
  no: !0,
  so: !0,
  ea: !0,
  we: !0,
  ce: !0,
  noea: !0,
  nowe: !0,
  soea: !0,
  sowe: !0
}, Ce = {
  ...C,
  sm: !0,
  fp: !0,
  obj: !0
}, Q = (t) => t.gravity || t.g, O = (t) => !!Q(t), y = (t, e) => `${e ? "" : "g:"}${t.replace(/:+$/, "")}`, v = (t, e = {}) => {
  const { headless: r = !1 } = e, o = Q(t);
  n(o, "gravity"), n(o.type, "gravity.type");
  const s = o.type;
  if (d(Ce, s, "gravity.type"), (o.x_offset || o.y_offset) && d(C, s, "gravity.type"), o.class_names && s !== "obj")
    throw new Error("gravity.class_names can be used only with type obj");
  if ((o.x || o.y) && s !== "fp")
    throw new Error("gravity.x and gravity.y can be used only with type fp");
  if (s === "sm")
    return y(s, r);
  if (s === "fp") {
    const a = o;
    return n(a.x, "gravity.x"), n(a.y, "gravity.y"), i(a.x, "gravity.x", { addParam: { min: 0, max: 1 } }), i(a.y, "gravity.y", { addParam: { min: 0, max: 1 } }), y(`${s}:${a.x}:${a.y}`, r);
  }
  if (s === "obj") {
    const a = o;
    n(o.class_names, "gravity.class_names"), $(a.class_names, "gravity.class_names");
    const c = a.class_names;
    return y(`${s}:${c.join(":")}`, r);
  } else {
    const a = o, c = a.x_offset === void 0 ? "" : a.x_offset, u = a.y_offset === void 0 ? "" : a.y_offset;
    return y(`${a.type}:${c}:${u}`, r);
  }
}, Qe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: v,
  test: O
}, Symbol.toStringTag, { value: "Module" })), D = (t) => t.crop || t.c, De = (t) => !!D(t), He = (t) => {
  const e = D(t);
  n(e, "crop");
  const { width: r, height: o } = e;
  n(r, "crop.width"), n(o, "crop.height"), i(r, "crop.width", { addParam: { min: 0 } }), i(o, "crop.height", { addParam: { min: 0 } });
  const s = O(e) ? v(e, { headless: !0 }) : "";
  return `c:${r}:${o}:${s}`.replace(/:+$/, "");
}, H = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: He,
  test: De
}, Symbol.toStringTag, { value: "Module" })), X = (t) => {
  if ("disable_animation" in t)
    return t.disable_animation;
  if ("da" in t)
    return t.da;
}, Xe = (t) => X(t) !== void 0, We = (t) => {
  const e = X(t);
  return n(e, "disable_animation"), `da:${l(e)}`;
}, Ye = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: We,
  test: Xe
}, Symbol.toStringTag, { value: "Module" })), W = (t) => t.dpi, Ge = (t) => !!W(t), Je = (t) => {
  const e = W(t);
  return n(e, "dpi"), i(e, "dpi"), `dpi:${e}`;
}, Ke = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: Je,
  test: Ge
}, Symbol.toStringTag, { value: "Module" })), Y = (t) => t.dpr, Le = (t) => !!Y(t), Ze = (t) => {
  const e = Y(t);
  return n(e, "dpr"), i(e, "dpr", { addParam: { min: 0 } }), `dpr:${e}`;
}, tr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: Ze,
  test: Le
}, Symbol.toStringTag, { value: "Module" })), G = (t) => t.draw_detections || t.dd, er = (t) => !!G(t), rr = (t) => {
  const e = G(t);
  n(e, "draw_detections"), n(e.draw, "draw_detections.draw");
  const r = l(e.draw), o = e.class_names ? `:${e.class_names.join(":")}` : "";
  return `dd:${r}${o}`;
}, or = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: rr,
  test: er
}, Symbol.toStringTag, { value: "Module" })), J = (t) => {
  if ("enforce_thumbnail" in t)
    return t.enforce_thumbnail;
  if ("eth" in t)
    return t.eth;
}, nr = (t) => J(t) !== void 0, sr = (t) => {
  const e = J(t);
  return n(e, "enforce_thumbnail"), `eth:${l(e)}`;
}, ir = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: sr,
  test: nr
}, Symbol.toStringTag, { value: "Module" })), K = (t) => {
  if ("enlarge" in t)
    return t.enlarge;
  if ("el" in t)
    return t.el;
}, ar = (t) => K(t) !== void 0, lr = (t) => {
  const e = K(t);
  return n(e, "enlarge"), `el:${l(e)}`;
}, cr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: lr,
  test: ar
}, Symbol.toStringTag, { value: "Module" })), L = (t) => t.expires || t.exp, ur = (t) => !!L(t), dr = (t) => {
  const e = L(t);
  return n(e, "expires"), i(e, "expires"), `exp:${e}`;
}, Z = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: dr,
  test: ur
}, Symbol.toStringTag, { value: "Module" })), tt = (t) => t.extend || t.ex, j = (t) => !!tt(t), br = (t, e) => `${e ? "" : "ex:"}${t.replace(/:+$/, "")}`, S = (t, e = {}) => {
  const { headless: r = !1 } = e, o = tt(t);
  n(o, "extend"), n(o.extend, "extend.extend");
  const s = O(o) ? `:${v(o, { headless: !0 })}` : "";
  return br(`${l(o.extend)}${s}`, r);
}, _r = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: S,
  test: j
}, Symbol.toStringTag, { value: "Module" })), et = (t) => t.extend_aspect_ratio || t.exar || t.extend_ar, mr = (t) => !!et(t), pr = (t) => {
  const e = et(t);
  n(e, "extend_aspect_ratio"), n(e.extend, "extend_aspect_ratio.extend");
  const r = O(e) ? `:${v(e, { headless: !0 })}` : "";
  return `exar:${l(e.extend)}${r}`;
}, gr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: pr,
  test: mr
}, Symbol.toStringTag, { value: "Module" })), rt = (t) => t.fallback_image_url || t.fiu, fr = (t) => !!rt(t), $r = (t) => {
  const e = rt(t);
  return n(e, "fallback_image_url"), _(e, "fallback_image_url"), `fiu:${e}`;
}, yr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: $r,
  test: fr
}, Symbol.toStringTag, { value: "Module" })), ot = (t) => t.filename || t.fn, Or = (t) => !!ot(t), vr = (t) => {
  const e = ot(t);
  n(e, "filename"), n(e.name, "filename.name"), _(e.name, "filename.name");
  const r = e.encoded === void 0 ? "" : `:${l(e.encoded)}`;
  return `fn:${e.name}${r}`;
}, hr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: vr,
  test: Or
}, Symbol.toStringTag, { value: "Module" })), jr = {
  png: !0,
  jpg: !0,
  webp: !0,
  avif: !0,
  gif: !0,
  ico: !0,
  svg: !0,
  bmp: !0,
  tiff: !0,
  mp4: !0,
  best: !0
}, nt = (t) => t.format || t.f || t.ext, Sr = (t) => !!nt(t), wr = (t) => {
  const e = nt(t);
  return n(e, "format"), d(jr, e, "format"), `f:${e}`;
}, zr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: wr,
  test: Sr
}, Symbol.toStringTag, { value: "Module" })), st = (t) => t.format_quality || t.fq, Pr = (t) => !!st(t), xr = (t) => {
  const e = st(t);
  n(e, "format_quality"), $(e, "format_quality");
  const r = [];
  return e.forEach((o) => {
    r.push(`${o.format}:${o.quality}`);
  }), `fq:${r.join(":")}`;
}, Mr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: xr,
  test: Pr
}, Symbol.toStringTag, { value: "Module" })), Tr = {
  down: !0,
  up: !0,
  right: !0,
  left: !0
}, it = (t) => t.gradient || t.gr, kr = (t) => !!it(t), Br = (t) => {
  const e = it(t);
  n(e, "gradient");
  const { opacity: r, color: o, direction: s, start: a, stop: c } = e;
  return n(r, "gradient.opacity"), i(r, "gradient.opacity", {
    addParam: { min: 0, max: 1 }
  }), o && _(o, "gradient.color", !0), s && (_(s, "gradient.direction"), d(Tr, s, "gradient.direction")), a && i(a, "gradient.start", { addParam: { min: 0, max: 1 } }), c && i(c, "gradient.stop", { addParam: { min: 0, max: 1 } }), `gr:${r}:${o || ""}:${s || ""}:${a || ""}:${c || ""}`.replace(/:+$/, "");
}, qr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: Br,
  test: kr
}, Symbol.toStringTag, { value: "Module" })), at = (t) => t.height || t.h, Er = (t) => !!at(t), Ir = (t) => {
  const e = at(t);
  return n(e, "height"), i(e, "height", { addParam: { min: 0 } }), `h:${e}`;
}, Ar = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: Ir,
  test: Er
}, Symbol.toStringTag, { value: "Module" })), lt = (t) => t.jpeg_options || t.jpgo, Fr = (t) => !!lt(t), Vr = (t) => {
  const e = lt(t);
  n(e, "jpeg_options");
  const {
    progressive: r,
    no_subsample: o,
    trellis_quant: s,
    overshoot_deringing: a,
    optimize_scans: c,
    quant_table: u
  } = e;
  if (r && p(r, "jpeg_options.progressive"), o && p(o, "jpeg_options.no_subsample"), s && p(s, "jpeg_options.trellis_quant"), a && p(a, "jpeg_options.overshoot_deringing"), c && (p(c, "jpeg_options.optimize_scans"), r === !1))
    throw new Error(
      "jpeg_options.progressive must be true if jpeg_options.optimize_scans is true"
    );
  return u && i(u, "jpeg_options.quant_table", {
    addParam: { min: 0, max: 8 }
  }), `jpgo:${r === void 0 ? "" : r}:${o === void 0 ? "" : o}:${s === void 0 ? "" : s}:${a === void 0 ? "" : a}:${c === void 0 ? "" : c}:${u === void 0 ? "" : u}`.replace(/:+$/, "");
}, Ur = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: Vr,
  test: Fr
}, Symbol.toStringTag, { value: "Module" })), ct = (t) => {
  if ("keep_copyright" in t)
    return t.keep_copyright;
  if ("kcr" in t)
    return t.kcr;
}, Rr = (t) => ct(t) !== void 0, Nr = (t) => {
  const e = ct(t);
  return n(e, "keep_copyright"), `kcr:${l(e)}`;
}, Cr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: Nr,
  test: Rr
}, Symbol.toStringTag, { value: "Module" })), ut = (t) => {
  if ("max_animation_frames" in t)
    return t.max_animation_frames;
  if ("maf" in t)
    return t.maf;
}, Qr = (t) => ut(t) !== void 0, Dr = (t) => {
  const e = ut(t);
  return n(e, "max_animation_frames"), i(e, "max_animation_frames", {
    addParam: { min: 0, minEqual: !0 }
  }), `maf:${e}`;
}, Hr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: Dr,
  test: Qr
}, Symbol.toStringTag, { value: "Module" })), dt = (t) => {
  if ("max_animation_frame_resolution" in t)
    return t.max_animation_frame_resolution;
  if ("mafr" in t)
    return t.mafr;
}, Xr = (t) => dt(t) !== void 0, Wr = (t) => {
  const e = dt(t);
  return n(e, "max_animation_frame_resolution"), i(e, "max_animation_frame_resolution", {
    addParam: { min: 0 }
  }), `mafr:${e}`;
}, Yr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: Wr,
  test: Xr
}, Symbol.toStringTag, { value: "Module" })), bt = (t) => t.max_bytes || t.mb, Gr = (t) => !!bt(t), Jr = (t) => {
  const e = bt(t);
  return n(e, "max_bytes"), i(e, "max_bytes", { addParam: { min: 0 } }), `mb:${e}`;
}, Kr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: Jr,
  test: Gr
}, Symbol.toStringTag, { value: "Module" })), _t = (t) => {
  if ("max_src_file_size" in t)
    return t.max_src_file_size;
  if ("msfs" in t)
    return t.msfs;
}, Lr = (t) => _t(t) !== void 0, Zr = (t) => {
  const e = _t(t);
  return n(e, "max_src_file_size"), i(e, "max_src_file_size", { addParam: { min: 0 } }), `msfs:${e}`;
}, mt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: Zr,
  test: Lr
}, Symbol.toStringTag, { value: "Module" })), pt = (t) => {
  if ("max_src_resolution" in t)
    return t.max_src_resolution;
  if ("msr" in t)
    return t.msr;
}, to = (t) => pt(t) !== void 0, eo = (t) => {
  const e = pt(t);
  return n(e, "max_src_resolution"), i(e, "max_src_resolution", {
    addParam: { min: 0, minEqual: !0 }
  }), `msr:${e}`;
}, gt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: eo,
  test: to
}, Symbol.toStringTag, { value: "Module" })), ft = (t) => t.min_height || t.mh, ro = (t) => !!ft(t), oo = (t) => {
  const e = ft(t);
  return n(e, "min_height"), i(e, "min_height", { addParam: { min: 0 } }), `mh:${e}`;
}, no = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: oo,
  test: ro
}, Symbol.toStringTag, { value: "Module" })), $t = (t) => t.min_width || t.mw, so = (t) => !!$t(t), io = (t) => {
  const e = $t(t);
  return n(e, "min_width"), i(e, "min_width", { addParam: { min: 0 } }), `mw:${e}`;
}, ao = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: io,
  test: so
}, Symbol.toStringTag, { value: "Module" })), yt = (t) => t.padding || t.pd, lo = (t) => !!yt(t), co = (t) => {
  const e = yt(t);
  if (n(e, "padding"), typeof e == "string")
    throw new Error("padding option is not a number or object");
  if (typeof e == "number")
    return i(e, "padding", { addParam: { min: 0 } }), `pd:${e}`;
  e.top && i(e.top, "padding.top"), e.right && i(e.right, "padding.right"), e.bottom && i(e.bottom, "padding.bottom"), e.left && i(e.left, "padding.left");
  const r = e.top || "", o = e.right || "", s = e.bottom || "", a = e.left || "";
  return `pd:${r}:${o}:${s}:${a}`.replace(/:+$/, "");
}, uo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: co,
  test: lo
}, Symbol.toStringTag, { value: "Module" })), Ot = (t) => {
  if ("page" in t)
    return t.page;
  if ("pg" in t)
    return t.pg;
}, bo = (t) => Ot(t) !== void 0, _o = (t) => {
  const e = Ot(t);
  return n(e, "page"), i(e, "page", { addParam: { min: 0, isInt: !0 } }), `pg:${e}`;
}, vt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: _o,
  test: bo
}, Symbol.toStringTag, { value: "Module" })), ht = (t) => {
  if ("pages" in t)
    return t.pages;
  if ("pgs" in t)
    return t.pgs;
}, mo = (t) => ht(t) !== void 0, po = (t) => {
  const e = ht(t);
  return n(e, "pages"), i(e, "pages", { addParam: { min: 1, isInt: !0 } }), `pgs:${e}`;
}, go = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: po,
  test: mo
}, Symbol.toStringTag, { value: "Module" })), jt = (t) => t.pixelate || t.pix, fo = (t) => !!jt(t), $o = (t) => {
  const e = jt(t);
  return n(e, "pixelate"), i(e, "pixelate", { addParam: { min: 0 } }), `pix:${e}`;
}, yo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: $o,
  test: fo
}, Symbol.toStringTag, { value: "Module" })), St = (t) => t.png_options || t.pngo, Oo = (t) => !!St(t), vo = (t) => {
  const e = St(t);
  n(e, "png_options");
  const { interlaced: r, quantize: o, quantization_colors: s } = e;
  return r && p(r, "png_options.interlaced"), o && p(o, "png_options.quantize"), s && i(s, "png_options.quantization_colors", {
    addParam: { min: 2, max: 256 }
  }), `pngo:${r === void 0 ? "" : r}:${o === void 0 ? "" : o}:${s || ""}`.replace(/:+$/, "");
}, ho = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: vo,
  test: Oo
}, Symbol.toStringTag, { value: "Module" })), wt = (t) => t.preset || t.pr, jo = (t) => !!wt(t), So = (t) => {
  const e = wt(t);
  if (n(e, "preset"), $(e, "preset"), e.some((r) => typeof r != "string"))
    throw new Error("preset option should contain only strings");
  return `pr:${e.join(":")}`;
}, zt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: So,
  test: jo
}, Symbol.toStringTag, { value: "Module" })), Pt = (t) => t.quality || t.q, wo = (t) => !!Pt(t), zo = (t) => {
  const e = Pt(t);
  return n(e, "quality"), i(e, "quality", { addParam: { min: 0, max: 100 } }), `q:${e}`;
}, Po = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: zo,
  test: wo
}, Symbol.toStringTag, { value: "Module" })), xt = (t) => {
  if ("raw" in t)
    return t.raw;
}, xo = (t) => xt(t) !== void 0, Mo = (t) => {
  const e = xt(t);
  return n(e, "raw"), `raw:${l(e)}`;
}, To = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: Mo,
  test: xo
}, Symbol.toStringTag, { value: "Module" })), ko = {
  fit: !0,
  fill: !0,
  auto: !0,
  "fill-down": !0,
  force: !0
}, Mt = (t) => t.resize || t.rs, Bo = (t) => !!Mt(t), qo = (t) => {
  const e = Mt(t);
  n(e, "resize");
  const { resizing_type: r, width: o, height: s, enlarge: a } = e;
  r && d(ko, r, "resize.resizing_type"), o && i(o, "resize.width", { addParam: { min: 0 } }), s && i(s, "resize.height", { addParam: { min: 0 } });
  const c = r || "", u = o || "", m = s || "", g = a === void 0 ? "" : l(a), f = j(e) ? S(e, { headless: !0 }) : "";
  return `rs:${c}:${u}:${m}:${g}:${f}`.replace(/:+$/, "");
}, Eo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: qo,
  test: Bo
}, Symbol.toStringTag, { value: "Module" })), Io = {
  nearest: !0,
  linear: !0,
  cubic: !0,
  lanczos2: !0,
  lanczos3: !0
}, Tt = (t) => t.resizing_algorithm || t.ra, Ao = (t) => !!Tt(t), Fo = (t) => {
  const e = Tt(t);
  return n(e, "resizing_algorithm"), d(Io, e, "resizing_algorithm"), `ra:${e}`;
}, Vo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: Fo,
  test: Ao
}, Symbol.toStringTag, { value: "Module" })), Uo = {
  fit: !0,
  fill: !0,
  "fill-down": !0,
  force: !0,
  auto: !0
}, kt = (t) => t.resizing_type || t.rt, Ro = (t) => !!kt(t), No = (t) => {
  const e = kt(t);
  return n(e, "resizing_type"), d(Uo, e, "resizing_type"), `rt:${e}`;
}, Co = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: No,
  test: Ro
}, Symbol.toStringTag, { value: "Module" })), Bt = (t) => {
  if ("return_attachment" in t)
    return t.return_attachment;
  if ("att" in t)
    return t.att;
}, Qo = (t) => Bt(t) !== void 0, Do = (t) => {
  const e = Bt(t);
  return n(e, "return_attachment"), `att:${l(e)}`;
}, Ho = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: Do,
  test: Qo
}, Symbol.toStringTag, { value: "Module" })), P = {
  0: !0,
  90: !0,
  180: !0,
  270: !0
}, qt = (t) => t.rotate || t.rot, Xo = (t) => !!qt(t), Wo = (t) => {
  const e = qt(t), r = `You can use values ${Object.keys(P).join(", ")}`;
  return n(e, "rotate"), i(e, "rotate", { addInfo: r }), d(P, e, "rotate"), `rot:${e}`;
}, Yo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: Wo,
  test: Xo
}, Symbol.toStringTag, { value: "Module" })), Et = (t) => t.saturation || t.sa, Go = (t) => !!Et(t), Jo = (t) => {
  const e = Et(t);
  return n(e, "saturation"), i(e, "saturation", { addParam: { min: 0 } }), `sa:${e}`;
}, Ko = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: Jo,
  test: Go
}, Symbol.toStringTag, { value: "Module" })), It = (t) => t.sharpen || t.sh, Lo = (t) => !!It(t), Zo = (t) => {
  const e = It(t);
  return n(e, "sharpen"), i(e, "sharpen", { addParam: { min: 0 } }), `sh:${e}`;
}, tn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: Zo,
  test: Lo
}, Symbol.toStringTag, { value: "Module" })), At = (t) => t.size || t.s, en = (t) => !!At(t), rn = (t) => {
  const e = At(t);
  n(e, "size");
  const { width: r, height: o, enlarge: s } = e;
  r && i(r, "size.width", { addParam: { min: 0 } }), o && i(o, "size.height", { addParam: { min: 0 } });
  const a = r || "", c = o || "", u = s === void 0 ? "" : l(s), m = j(e) ? S(e, { headless: !0 }) : "";
  return `s:${a}:${c}:${u}:${m}`.replace(/:+$/, "");
}, on = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: rn,
  test: en
}, Symbol.toStringTag, { value: "Module" })), x = [
  "jpg",
  "png",
  "webp",
  "avif",
  "gif",
  "ico",
  "svg",
  "heic",
  "bmp",
  "tiff",
  "pdf",
  "mp4"
], Ft = (t) => t.skip_processing || t.sp, nn = (t) => !!Ft(t), sn = (t) => {
  const e = Ft(t);
  if (n(e, "skip_processing"), $(e, "skip_processing"), e.some((r) => !x.includes(r))) {
    const r = `Valid values are: ${x.join(",")}`;
    throw new Error(
      `skip_processing option contains unsupported extension. ${r}`
    );
  }
  return `sp:${e.join(":")}`;
}, an = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: sn,
  test: nn
}, Symbol.toStringTag, { value: "Module" })), Vt = (t) => {
  if ("strip_color_profile" in t)
    return t.strip_color_profile;
  if ("scp" in t)
    return t.scp;
}, ln = (t) => Vt(t) !== void 0, cn = (t) => {
  const e = Vt(t);
  return n(e, "strip_color_profile"), `scp:${l(e)}`;
}, un = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: cn,
  test: ln
}, Symbol.toStringTag, { value: "Module" })), Ut = (t) => "strip_metadata" in t ? t.strip_metadata : "sm" in t ? t.sm : void 0, dn = (t) => Ut(t) !== void 0, bn = (t) => {
  const e = Ut(t);
  return n(e, "strip_metadata"), `sm:${l(e)}`;
}, _n = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: bn,
  test: dn
}, Symbol.toStringTag, { value: "Module" })), Rt = (t) => t.style || t.stl, mn = (t) => !!Rt(t), pn = (t) => {
  const e = Rt(t);
  return n(e, "style"), _(e, "style"), `stl:${e}`;
}, gn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: pn,
  test: mn
}, Symbol.toStringTag, { value: "Module" })), Nt = (t) => t.trim || t.t, fn = (t) => !!Nt(t), $n = (t) => {
  const e = Nt(t);
  n(e, "trim");
  const { threshold: r, color: o, equal_hor: s, equal_ver: a } = e;
  n(r, "trim.threshold"), i(r, "trim.threshold"), o && _(o, "trim.color", !0);
  const c = s === void 0 ? "" : l(s), u = a === void 0 ? "" : l(a);
  return `t:${r}:${o || ""}:${c}:${u}`.replace(/:+$/, "");
}, yn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: $n,
  test: fn
}, Symbol.toStringTag, { value: "Module" })), On = {
  auto: !0,
  none: !0,
  always: !0
}, Ct = (t) => t.unsharp_masking || t.ush, vn = (t) => !!Ct(t), hn = (t) => {
  const e = Ct(t);
  n(e, "unsharp_masking");
  const { mode: r, weight: o, divider: s } = e;
  return r && d(On, r, "unsharp_masking.mode"), o && i(o, "unsharp_masking.weight", {
    addParam: { min: 0, minEqual: !0 }
  }), s && i(s, "unsharp_masking.divider", {
    addParam: { min: 0, minEqual: !0 }
  }), `ush:${r || ""}:${o || ""}:${s || ""}`.replace(/:+$/, "");
}, jn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: hn,
  test: vn
}, Symbol.toStringTag, { value: "Module" })), Qt = (t) => {
  if ("video_thumbnail_second" in t)
    return t.video_thumbnail_second;
  if ("vts" in t)
    return t.vts;
}, Sn = (t) => Qt(t) !== void 0, wn = (t) => {
  const e = Qt(t);
  return n(e, "video_thumbnail_second"), i(e, "video_thumbnail_second", {
    addParam: { min: 1, isInt: !0 }
  }), `vts:${e}`;
}, Dt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: wn,
  test: Sn
}, Symbol.toStringTag, { value: "Module" })), zn = {
  ce: !0,
  no: !0,
  so: !0,
  ea: !0,
  we: !0,
  noea: !0,
  nowe: !0,
  soea: !0,
  sowe: !0,
  re: !0
}, Ht = (t) => t.watermark || t.wm, Pn = (t) => !!Ht(t), xn = (t) => {
  const e = Ht(t);
  n(e, "watermark");
  const { opacity: r, position: o, x_offset: s, y_offset: a, scale: c } = e;
  return n(r, "watermark.opacity"), i(r, "watermark.opacity", { addParam: { min: 0, max: 1 } }), o && (_(o, "watermark.position"), d(zn, o, "watermark.position")), s && i(s, "watermark.x_offset"), a && i(a, "watermark.y_offset"), c && i(c, "watermark.scale"), `wm:${r}:${o || ""}:${s || ""}:${a || ""}:${c || ""}`.replace(/:+$/, "");
}, Mn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: xn,
  test: Pn
}, Symbol.toStringTag, { value: "Module" })), Xt = (t) => t.watermark_shadow || t.wmsh, Tn = (t) => !!Xt(t), kn = (t) => {
  const e = Xt(t);
  return n(e, "watermark_shadow"), i(e, "watermark_shadow", {
    addParam: { min: 0 }
  }), `wmsh:${e}`;
}, Bn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: kn,
  test: Tn
}, Symbol.toStringTag, { value: "Module" })), Wt = (t) => t.watermark_size || t.wms, qn = (t) => !!Wt(t), En = (t) => {
  const e = Wt(t);
  n(e, "watermark_size");
  const { width: r, height: o } = e;
  return r && i(r, "watermark_size.width", { addParam: { min: 0 } }), o && i(o, "watermark_size.height", { addParam: { min: 0 } }), `wms:${r || ""}:${o || ""}`.replace(/:+$/, "");
}, In = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: En,
  test: qn
}, Symbol.toStringTag, { value: "Module" })), Yt = (t) => t.watermark_text || t.wmt, An = (t) => !!Yt(t), Fn = (t) => {
  const e = Yt(t);
  return n(e, "watermark_text"), _(e, "watermark_text"), `wmt:${e}`;
}, Vn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: Fn,
  test: An
}, Symbol.toStringTag, { value: "Module" })), Gt = (t) => t.watermark_url || t.wmu, Un = (t) => !!Gt(t), Rn = (t) => {
  const e = Gt(t);
  return n(e, "watermark_url"), _(e, "watermark_url"), `wmu:${e}`;
}, Nn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: Rn,
  test: Un
}, Symbol.toStringTag, { value: "Module" })), Cn = {
  lossy: !0,
  near_lossless: !0,
  lossless: !0
}, Jt = (t) => t.webp_options || t.webpo, Qn = (t) => !!Jt(t), Dn = (t) => {
  const e = Jt(t);
  return n(e, "webp_options"), d(Cn, e, "webp_options"), `webpo:${e}`;
}, Hn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: Dn,
  test: Qn
}, Symbol.toStringTag, { value: "Module" })), Kt = (t) => t.width || t.w, Xn = (t) => !!Kt(t), Wn = (t) => {
  const e = Kt(t);
  return n(e, "width"), i(e, "width", { addParam: { min: 0 } }), `w:${e}`;
}, Yn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: Wn,
  test: Xn
}, Symbol.toStringTag, { value: "Module" })), h = (t, e) => {
  n(t, e), i(t, e, { addParam: { min: 0 } });
}, Lt = (t) => t.zoom || t.z, Gn = (t) => !!Lt(t), Jn = (t) => {
  const e = Lt(t);
  return n(e, "zoom"), typeof e == "string" && i(e, "zoom"), typeof e == "number" ? (h(e, "zoom"), `z:${e}`) : (h(e.zoom_x, "zoom.zoom_x"), h(e.zoom_y, "zoom.zoom_y"), `z:${e.zoom_x}:${e.zoom_y}`);
}, Kn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: Jn,
  test: Gn
}, Symbol.toStringTag, { value: "Module" })), Ln = (t) => t.wild_options, Zn = (t) => !!Ln(t), ts = (t) => {
  const e = t.wild_options;
  if (n(e, "raw_options"), $(e, "raw_options"), !e.every((o) => Array.isArray(o)))
    throw new Error("raw_options is not an array of arrays");
  let r = "";
  for (let o = 0; o < e.length; o++) {
    let s = "";
    for (let a = 0; a < e[o].length; a++)
      a > 0 && (s += ":"), s += e[o][a];
    o > 0 && (r += "/"), r += s;
  }
  return r;
}, Zt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: ts,
  test: Zn
}, Symbol.toStringTag, { value: "Module" })), es = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ajust: me,
  autoRotate: ve,
  autoquality: $e,
  background: Se,
  backgroundAlpha: Pe,
  blur: Te,
  blurDetections: qe,
  brightness: Ae,
  cacheBuster: R,
  contrast: Ne,
  crop: H,
  disableAnimation: Ye,
  dpi: Ke,
  dpr: tr,
  drawDetections: or,
  enforceThumbnail: ir,
  enlarge: cr,
  expires: Z,
  extend: _r,
  extendAspectRatio: gr,
  fallbackImageUrl: yr,
  filename: hr,
  format: zr,
  formatQuality: Mr,
  gradient: qr,
  gravity: Qe,
  height: Ar,
  jpegOptions: Ur,
  keepCopyright: Cr,
  maxAnimationFrameResolution: Yr,
  maxAnimationFrames: Hr,
  maxBytes: Kr,
  maxSrcFileSize: mt,
  maxSrcResolution: gt,
  minHeight: no,
  minWidth: ao,
  padding: uo,
  page: vt,
  pages: go,
  pixelate: yo,
  pngOptions: ho,
  preset: zt,
  quality: Po,
  raw: To,
  resize: Eo,
  resizingAlgorithm: Vo,
  resizingType: Co,
  returnAttachment: Ho,
  rotate: Yo,
  saturation: Ko,
  sharpen: tn,
  size: on,
  skipProcessing: an,
  stripColorProfile: un,
  stripMetadata: _n,
  style: gn,
  trim: yn,
  unsharpMasking: jn,
  videoThumbnailSecond: Dt,
  watermark: Mn,
  watermarkShadow: Bn,
  watermarkSize: In,
  watermarkText: Vn,
  watermarkUrl: Nn,
  webpOptions: Hn,
  width: Yn,
  wildOptions: Zt,
  zoom: Kn
}, Symbol.toStringTag, { value: "Module" })), M = {
  plain: !0,
  base64: !0,
  encrypted: !0
}, Ns = (t, e) => {
  n(t.value, "url.value", "Must be a string"), n(
    t.type,
    "url.type",
    `Valid values are: ${Object.keys(M).join(", ")}`
  ), d(M, t.type, "url.type");
  let r = "";
  if (e)
    for (const [, s] of Object.entries(es))
      s.test(e) && (r += "/", r += s.build(e));
  let o = "";
  return t.type === "plain" ? o = `/plain/${t.value}` : t.type === "base64" ? o = `/${t.value}` : t.type === "encrypted" && (o = `/enc/${t.value}`), `${r}${o}`;
}, te = (t) => {
  if ("average" in t)
    return t.average;
  if ("avg" in t)
    return t.avg;
}, rs = (t) => te(t) !== void 0, os = (t) => {
  const e = te(t);
  n(e, "average"), n(e.average, "average.average");
  const r = e.ignore_transparent === void 0 ? "" : `:${l(e.ignore_transparent)}`;
  return `avg:${l(e.average)}${r}`;
}, ns = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: os,
  test: rs
}, Symbol.toStringTag, { value: "Module" })), ee = (t) => {
  if ("blurhash" in t)
    return t.blurhash;
  if ("bh" in t)
    return t.bh;
}, ss = (t) => ee(t) !== void 0, is = (t) => {
  const e = ee(t);
  n(e, "blurhash");
  const { x_components: r, y_components: o } = e;
  return n(r, "blurhash.x_components"), n(o, "blurhash.y_components"), i(r, "blurhash.x_components", {
    addParam: { min: 0, max: 9 }
  }), i(o, "blurhash.y_components", {
    addParam: { min: 0, max: 9 }
  }), `bh:${r}:${o}`;
}, as = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: is,
  test: ss
}, Symbol.toStringTag, { value: "Module" })), re = (t) => {
  if ("detect_objects" in t)
    return t.detect_objects;
  if ("do" in t)
    return t.do;
}, ls = (t) => re(t) !== void 0, cs = (t) => {
  const e = re(t);
  return n(e, "detect_objects"), `do:${l(e)}`;
}, us = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: cs,
  test: ls
}, Symbol.toStringTag, { value: "Module" })), oe = (t) => {
  if ("dimensions" in t)
    return t.dimensions;
  if ("d" in t)
    return t.d;
}, ds = (t) => oe(t) !== void 0, bs = (t) => {
  const e = oe(t);
  return n(e, "dimensions"), `d:${l(e)}`;
}, _s = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: bs,
  test: ds
}, Symbol.toStringTag, { value: "Module" })), ne = (t) => {
  if ("dominant_colors" in t)
    return t.dominant_colors;
  if ("dc" in t)
    return t.dc;
}, ms = (t) => ne(t) !== void 0, ps = (t) => {
  const e = ne(t);
  n(e, "dominant_colors"), n(e.dominant_colors, "dominant_colors.dominant_colors");
  const r = e.build_missed === void 0 ? "" : `:${l(e.build_missed)}`;
  return `dc:${l(e.dominant_colors)}${r}`;
}, gs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: ps,
  test: ms
}, Symbol.toStringTag, { value: "Module" })), se = (t) => {
  if ("exif" in t)
    return t.exif;
}, fs = (t) => se(t) !== void 0, $s = (t) => {
  const e = se(t);
  return n(e, "EXIF"), `exif:${l(e)}`;
}, ys = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: $s,
  test: fs
}, Symbol.toStringTag, { value: "Module" })), ie = (t) => {
  if ("format" in t)
    return t.format;
  if ("f" in t)
    return t.f;
}, Os = (t) => ie(t) !== void 0, vs = (t) => {
  const e = ie(t);
  return n(e, "format"), `f:${l(e)}`;
}, hs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: vs,
  test: Os
}, Symbol.toStringTag, { value: "Module" })), ae = (t) => {
  if ("iptc" in t)
    return t.iptc;
}, js = (t) => ae(t) !== void 0, Ss = (t) => {
  const e = ae(t);
  return n(e, "IPTC"), `iptc:${l(e)}`;
}, ws = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: Ss,
  test: js
}, Symbol.toStringTag, { value: "Module" })), le = (t) => {
  if ("palette" in t)
    return t.palette;
  if ("p" in t)
    return t.p;
}, zs = (t) => le(t) !== void 0, Ps = (t) => {
  const e = le(t);
  if (n(e, "palette"), i(e, "palette", {
    addParam: { min: 0, max: 256, isInt: !0 }
  }), e === 1)
    throw new Error("palette option is should be 0 or between 2 and 256");
  return `p:${e}`;
}, xs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: Ps,
  test: zs
}, Symbol.toStringTag, { value: "Module" })), ce = (t) => {
  if ("size" in t)
    return t.size;
  if ("s" in t)
    return t.s;
}, Ms = (t) => ce(t) !== void 0, Ts = (t) => {
  const e = ce(t);
  return n(e, "size"), `s:${l(e)}`;
}, ks = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: Ts,
  test: Ms
}, Symbol.toStringTag, { value: "Module" })), ue = (t) => {
  if ("video_meta" in t)
    return t.video_meta;
  if ("vm" in t)
    return t.vm;
}, Bs = (t) => ue(t) !== void 0, qs = (t) => {
  const e = ue(t);
  return n(e, "video_meta"), `vm:${l(e)}`;
}, Es = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: qs,
  test: Bs
}, Symbol.toStringTag, { value: "Module" })), de = (t) => {
  if ("xmp" in t)
    return t.xmp;
}, Is = (t) => de(t) !== void 0, As = (t) => {
  const e = de(t);
  return n(e, "XMP"), `xmp:${l(e)}`;
}, Fs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: As,
  test: Is
}, Symbol.toStringTag, { value: "Module" })), Vs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  average: ns,
  blurhash: as,
  cacheBuster: R,
  crop: H,
  detectObjects: us,
  dimensions: _s,
  dominantColors: gs,
  exif: ys,
  expires: Z,
  format: hs,
  iptc: ws,
  maxSrcFileSize: mt,
  maxSrcResolution: gt,
  page: vt,
  palette: xs,
  preset: zt,
  size: ks,
  videoMeta: Es,
  videoThumbnailSecond: Dt,
  wildOptions: Zt,
  xmp: Fs
}, Symbol.toStringTag, { value: "Module" })), T = {
  plain: !0,
  base64: !0,
  encrypted: !0
}, Cs = (t, e) => {
  n(t.value, "url.value", "Must be a string"), n(
    t.type,
    "url.type",
    `Valid values are: ${Object.keys(T).join(", ")}`
  ), d(T, t.type, "url.type");
  let r = "";
  if (e)
    for (const [, s] of Object.entries(Vs))
      s.test(e) && (r += "/", r += s.build(e));
  let o = "";
  return t.type === "plain" ? o = `/plain/${t.value}` : t.type === "base64" ? o = `/${t.value}` : t.type === "encrypted" && (o = `/enc/${t.value}`), `${r}${o}`;
}, Qs = "/info";
export {
  Qs as INFO_PREFIX,
  Cs as generateImageInfoUrl,
  Ns as generateUrl
};
